var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAddCircleBlue = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "#118AF9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.994,12.735a7.468,7.468,0,0,0-2.729-2.729,7.548,7.548,0,0,0-7.529,0,7.467,7.467,0,0,0-2.73,2.729,7.548,7.548,0,0,0,0,7.529,7.468,7.468,0,0,0,2.73,2.729,7.548,7.548,0,0,0,7.529,0,7.467,7.467,0,0,0,2.729-2.729,7.549,7.549,0,0,0,0-7.529Zm-2.119,4.39a.634.634,0,0,1-.625.625h-2.5v2.5a.634.634,0,0,1-.625.625h-1.25a.634.634,0,0,1-.625-.625v-2.5h-2.5a.634.634,0,0,1-.625-.625v-1.25a.634.634,0,0,1,.625-.625h2.5v-2.5a.634.634,0,0,1,.625-.625h1.25a.634.634,0,0,1,.625.625v2.5h2.5a.634.634,0,0,1,.625.625Z",
    transform: "translate(-30 -9)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddCircleBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add-circle-blue.0554377c.svg";
export { ForwardRef as ReactComponent };